import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "header__heading" }
const _hoisted_2 = {
  key: 0,
  class: "page-header__description"
}
const _hoisted_3 = { class: "page-header__heading" }
const _hoisted_4 = {
  key: 0,
  class: "page-header__description"
}
const _hoisted_5 = {
  key: 1,
  class: "page-header__buttons"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_placeholders_text = _resolveComponent("content-placeholders-text")!
  const _component_content_placeholders = _resolveComponent("content-placeholders")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["page-header", {
			'page-header--width-full': _ctx.widthFull,
			'page-header--reserve-vertical-space': _ctx.reserveVerticalSpace,
			'page-header--has-no-description': !_ctx.hasDescription,
		}])
  }, [
    (_ctx.dummy)
      ? (_openBlock(), _createBlock(_component_content_placeholders, {
          key: 0,
          animated: "",
          class: "header__placeholders"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, [
              _createVNode(_component_content_placeholders_text, { lines: 1 })
            ]),
            (_ctx.hasDescription)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
                  _createVNode(_component_content_placeholders_text, { lines: 3 })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("h2", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.heading), 1)
            ])
          ]),
          (_ctx.hasDescription)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                _renderSlot(_ctx.$slots, "description", {}, () => [
                  _createTextVNode(_toDisplayString(_ctx.description), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.hasButtons)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "buttons")
              ]))
            : _createCommentVNode("", true)
        ], 64))
  ], 2))
}